import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MAX_FILE_BYTES = 10 * 1024 * 1024;

/**
 * Chat attachment upload state + handlers.
 * - `attachments` — array of uploaded file metadata `{ file_id, name, ... }`
 * - `uploading`  — boolean, true while a POST is in flight
 * - `onFiles(fileInputEvent)` — handles the <input type="file"> change event
 * - `remove(index)` — pop an attachment out of the list
 * - `reset()`      — clear everything (call after successful send)
 */
export default function useAttachments() {
  const [attachments, setAttachments] = useState([]);
  const [uploading, setUploading] = useState(false);

  const onFiles = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = '';
    if (!files.length) return;
    setUploading(true);
    try {
      for (const f of files) {
        if (f.size > MAX_FILE_BYTES) {
          toast.error(`${f.name} は10MBを超えています`);
          continue;
        }
        const fd = new FormData();
        fd.append('file', f);
        const res = await axios.post(`${API}/chat/attachments`, fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        setAttachments((prev) => [...prev, res.data]);
      }
    } catch (err) {
      console.error('[chat] upload failed', err);
      toast.error('アップロードに失敗しました');
    } finally {
      setUploading(false);
    }
  };

  const remove = (idx) => setAttachments((prev) => prev.filter((_, i) => i !== idx));
  const reset = () => setAttachments([]);

  return { attachments, uploading, onFiles, remove, reset };
}
